import React, { useState, Children } from 'react'
import { findLast } from 'lodash-es'

import PropTypes from 'prop-types'

import styled from 'styled-components'

const ExportMenuContainer = styled.div `
  display: flex;
  flex-direction: row-reverse;
  column-gap: 1px;
  width: fit-content;
  height: auto;
  position: ${({position}) => Boolean(position) ? "absolute" : ""};
  top: ${({top}) => top};
  right: ${({right}) => right};
  bottom: ${({bottom}) => bottom};
  left: ${({left}) => left};
  z-index: 100;
`
const MainButton = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  width: 31px;
  height: 31px;
  border-radius: 3px;
  background-color: ${({menuIsOpen}) => menuIsOpen ? "#ACACAC" : "#DDDDDD"};
  user-select: none;
  transition: 0.2s;
  span {
    height: 31px;
  }
`

const ColumnMenu = styled.div `
  display: flex;
  flex-direction: column;
  row-gap: 1px;
  height: auto;
  width: fit-content;
`

const MenuButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100%;
  max-width: fit-content;
  padding: 0 15px
  height: 34px;
  border-radius: 3px;
  font-size: 16px;
  background-color: ${({isSelected}) => isSelected ? "#ACACAC" : "#DDDDDD"};
  cursor: ${({isSubMenu}) => isSubMenu && "pointer"};
  opacity: 0.95;
  transition: 0.2s;
  user-select: none;
  &:hover {
    background-color: #ACACAC;
  }
`

const ExportMenu = ({
  exportMenuPosition,
  exportMenuId,
  exportPNG,
  exportCSV,
  exportXLSX,
  exportPDF,
  exportImgPDF,
}) => {

  const [showMenu, setShowMenu] = useState(false)
  const [menuSelected, setMenuSelected] = useState()

  const menus = [
    {
      label: "Image",
      menu: [
        { type: "PNG", label: "PNG", function: exportPNG }
      ]
    },{
      label: "Data",
      menu: [
        { type: "csv", label: "CSV", function: exportCSV },
        { type: "xlsx", label: "XLSX", function: exportXLSX },
        { type: "pdf", label: "PDF", function: exportPDF },
      ]
    },
  ]

  if(exportImgPDF !== undefined)
    menus[0].menu.push({type: "pdf", label: "PDF", function: exportImgPDF})

  const hideMenus = () => {
    setMenuSelected()
    setShowMenu(false)
  }
  

  const returnMenuSelected = () => {
    const menuToReturn = findLast(menus, menu => menu.label === menuSelected)
    return menuToReturn.menu
  }
  
  return (
    <ExportMenuContainer 
      id={exportMenuId}
      position={Boolean(exportMenuPosition)}
      top={exportMenuPosition?.top}
      right={exportMenuPosition?.right}
      bottom={exportMenuPosition?.bottom}
      left={exportMenuPosition?.left}
      onMouseEnter={() => setShowMenu(true)} 
      onMouseLeave={hideMenus}
    >
      <MainButton menuIsOpen={showMenu}>
        <span>...</span>
      </MainButton>
      {showMenu &&
        <ColumnMenu>
          {Children.toArray(menus.map(menu =>
            <MenuButton 
              isSelected={menuSelected === menu.label}
              onMouseEnter={() => setMenuSelected(menu.label)}
            >
              {menu.label}
            </MenuButton>
          ))}
        </ColumnMenu>
      }
      {Boolean(menuSelected) &&
        <ColumnMenu>
          {Children.toArray(returnMenuSelected().map(menu =>
            <MenuButton isSubMenu={true} onClick={menu.function}>
              {menu.label}
            </MenuButton>
          ))}
        </ColumnMenu>
      }
    </ExportMenuContainer>
  )
}

ExportMenu.propTypes = {
  exportMenuPosition: PropTypes.object,
  exportPNG: PropTypes.func,
  exportCSV: PropTypes.func,
  exportXLSX: PropTypes.func,
  exportPDF: PropTypes.func,
}

ExportMenu.defaultProps = {
  exportMenuPosition: {
    top: "",
    right: "",
    bottom: "",
    left: "",
  },
  exportMenuId: `exportMenu${Math.random()}`,
  exportPNG: () => {},
  exportCSV: () => {},
  exportXLSX: () => {},
  exportPDF: () => {},
}

export default ExportMenu
